import { render } from "./UfLegno.vue?vue&type=template&id=9e696898"
import script from "./UfLegno.vue?vue&type=script&lang=js"
export * from "./UfLegno.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__